import styled, { css } from 'styled-components';
import { Headline3 } from './../../app/common/typography/index';

export const InputContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const Input = styled.input(
  ({ theme, errorStatus }) => css`
    box-sizing: border-box;
    width: 45px;
    height: 50px;
    background: ${theme.colors.white};
    border: 1px solid
      ${errorStatus ? theme.spacing.redCrayola : theme.spacing.battleShipGray};
    border-radius: ${theme.radius.xs};
    text-align: center;
    font-size: 22px;
    font-weight: ${theme.fontWeight.bold};
  `
);

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 0 ${({ theme }) => theme.spacing.m};
`;

export const SubTitle = styled(Headline3)``;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const ButtonBlockColumn = styled.div`
  margin-top: ${({ theme }) => theme.spacing.l};
`;
